/* eslint-disable @typescript-eslint/no-var-requires */
export const Images = {
	logo: require('./logo.svg').default,

	//#region dashboard
	ar: require('./ar.png'),
	fr: require('./fr.png'),
	pm: require('./pm.png'),
	//#endregion

	//#region menu
	iconMenuHamburger: require('./menu/hamburger.svg').default,
	iconMenuResizable: require('./menu/resizable.svg').default,
	iconAccommodation: require('./menu/accommodation.svg').default,
	iconAssignment: require('./menu/assignment.svg').default,
	iconBasicInfo: require('./menu/basic_info.svg').default,
	iconBusiness: require('./menu/business.svg').default,
	iconBusinessSite: require('./menu/business_site.svg').default,
	iconChangeOfWorkplace: require('./menu/change_of_workplace.svg').default,
	iconCSM: require('./menu/csm.svg').default,
	iconDashboard: require('./menu/dashboard.svg').default,
	iconDocument: require('./menu/document.svg').default,
	iconExtensionOfStay: require('./menu/extension_of_stay.svg').default,
	iconOperations: require('./menu/operations.svg').default,
	iconPayroll: require('./menu/payroll.svg').default,
	iconProfile: require('./menu/profile.svg').default,
	iconProgram: require('./menu/program.svg').default,
	iconReferrer: require('./menu/referrer.svg').default,
	iconUnauthorizedDeparture: require('./menu/unauthorized_departure.svg')
		.default,
	iconWorker: require('./menu/worker.svg').default,
	//#endregion

	//#region icons
	iconSetting: require('./icon_setting.svg').default,
	iconCloseRed: require('./icon_close_red.svg').default,
	iconCloseMini: require('./icon_close_mini.svg').default,
	iconTriangleDown: require('./icon_triangle_down.svg').default,
	iconAvatar: require('./icon_avatar.svg').default,
	iconUpload: require('./icon_upload.svg').default,
	iconDownload: require('./icon_download.svg').default,
	iconBannerLogin: require('./icon_banner_login.svg').default,
	iconLogoLogin: require('./icon_logo_login.svg').default,
	iconExpand: require('./icon_expand.svg').default,
	iconDisc: require('./icon_disc.svg').default,
	iconBreadcrumbHome: require('./icon_breadcrumb_home.svg').default,
	iconBreadcrumbSeparator: require('./icon_breadcrumb_separator.svg').default,
	iconAttachFileRemove: require('./icon_attach_file_remove.svg').default,
	iconUploadImage: require('./icon_upload_image.svg').default,
	iconDownloadAvatar: require('./icon_download_avatar.svg').default,
	iconNamePlate: require('./icon_name_plate.svg').default,
	iconFrontBgNamePlate: require('./icon_front_bg_name_plate.svg').default,
	iconTableBuildingEstate: require('./tabler_building_estate.svg').default,
	iconMoonProfile: require('./iconamoon_profile.svg').default,
	iconArrowGray: require('./icon_arrow_gray.svg').default,
	iconElGroup: require('./icon_el_group.svg').default,
	iconArrowBlack: require('./icon_arrow_black.svg').default,
	avatarDefaultNamePlate: require('./avatar_default_name_plate.svg').default,
	iconDeleteImg: require('./icon_delete_img.svg').default,

	//#endregion

	//#region form
	formEmploymentChangeReportFrontSide: require('./pdf-images/form-employment-change-report-front-side.png'),
	formEmploymentChangeReportFrontSideHighlight: require('./pdf-images/form-employment-change-report-front-side-highlight.png'),
	formEmploymentChangeReportBackSide: require('./pdf-images/form-employment-change-report-back-side.jpg'),
	formConfirmEmployerPlaceWorker: require('./pdf-images/confirm-employer-place-worker.png'),
	formConfirmEmployerPlaceWorkerHighlight: require('./pdf-images/confirm-employer-place-worker-highlight.jpg'),

	integratedApplication: require('./pdf-images/integrated-application.png'),
	integratedApplicationHighlight: require('./pdf-images/integrated-application-highlight.png'),

	standardLaborContract1: require('./pdf-images/form-standard-labor-contract-1.png'),
	standardLaborContract2: require('./pdf-images/form-standard-labor-contract-2.png'),
	standardLaborContract3: require('./pdf-images/form-standard-labor-contract-3.png'),

	deductionAgreement: require('./pdf-images/deduction.png'),
	deductionAgreementHighlight: require('./pdf-images/deduction-highlight.png'),
	formResidence: require('./pdf-images/form-residence.png'),
	renewStayRecommendation: require('./pdf-images/form-renew-stay-recommendation.jpg'),
	renewStayRecommendationHighlight: require('./pdf-images/form-renew-stay-recommendation-highlight.jpg'),
	renewStayApplication: require('./pdf-images/form-renew-stay-application.png'),
	renewStayApplicationHighlight: require('./pdf-images/form-renew-stay-application-highlight.png'),
	formMarried: require('./pdf-images/form-married.png'),
	formMarriedHighlight: require('./pdf-images/form-married-highlight.jpg'),
	formDomesticStay: require('./pdf-images/form-domestic-stay.png'),
	formDomesticStayHighlight: require('./pdf-images/form-domestic-stay_highlight.png'),
	formParticipationSeasonalWork: require('./pdf-images/form_confirmation_of_participation_in_seasonal_work.png'),
	formParticipationSeasonalWorkHighlight: require('./pdf-images/form_confirmation_of_participation_in_seasonal_work_highlight.png'),
	attractionPlan1: require('./pdf-images/form-attraction-plan-1.png'),
	attractionPlan1Highlight: require('./pdf-images/form-attraction-plan-1-highlight.png'),
	attractionPlan2: require('./pdf-images/form-attraction-plan-2.png'),
	attractionPlan2Highlight: require('./pdf-images/form-attraction-plan-2-highlight.png'),
	attractionPlan3: require('./pdf-images/form-attraction-plan-3.png'),
	attractionPlan3Highlight: require('./pdf-images/form-attraction-plan-3-highlight.png'),
	formConfirmationOfSubscriptionToAgriculturalAndFishermanSafetyInsurance: require('./pdf-images/form-confirmation-of-subscription-to-agricultural-and-fisherman-safety-insurance.png'),
	formConfirmationOfSubscriptionToAgriculturalAndFishermanSafetyInsuranceHighlight: require('./pdf-images/form-confirmation-of-subscription-to-agricultural-and-fisherman-safety-insurance-highlight.jpg'),
	formIndicatorsForIdentifyingVictimsOfHumanRightsViolations: require('./pdf-images/form-indicators-for-identifying-victims-of-human-rights-violations.jpg'),
	formIndicatorsForIdentifyingVictimsOfHumanRightsViolationsHighlight: require('./pdf-images/form-indicators-for-identifying-victims-of-human-rights-violations-highlight.jpg'),
	formSeasonalWorkerReEntryRecommendationConfirmation: require('./pdf-images/form-seasonal-worker-re-entry-recommendation-confirmation.png'),
	formSeasonalWorkerReEntryRecommendationConfirmationHighlight: require('./pdf-images/form-seasonal-worker-re-entry-recommendation-confirmation-highlight.jpg'),
	formAccommodationPage1: require('./pdf-images/form-accommodation-page1.png'),
	formAccommodationPage1Highlight: require('./pdf-images/form-accommodation-page1-highlight.png'),
	formAccommodationPage2: require('./pdf-images/form-accommodation-page2.png'),
	formAccommodationPage2Highlight: require('./pdf-images/form-accommodation-page2-highlight.png'),
	formAccommodationPage3: require('./pdf-images/form-accommodation-page3.png'),
	formAccommodationPage3Highlight: require('./pdf-images/form-accommodation-page3-highlight.png'),
	formAccommodationFacilities: require('./pdf-images/accommodation-facilities.png'),
	formAccommodationFacilitiesHighlight: require('./pdf-images/accommodation-facilities-highlight.png'),
	formEmployerDeductionPointsCalculationStandardsViolateTheComplianceContents: require('./pdf-images/form-employer-deduction-points-calculation-standards-violate-the-compliance-contents.png'),
	formEmployerCertificateOfViolation: require('./pdf-images/form-employer-certificate-of-violation.png'),
	formEmployerCertificateOfViolationHighlight: require('./pdf-images/form-employer-certificate-of-violation-highlight.png'),
	formOrganizationCertificateOfViolation: require('./pdf-images/form-organization-certificate-of-violation.png'),
	formOrganizationCertificateOfViolationHighlight: require('./pdf-images/form-organization-certificate-of-violation-highlight.png'),
	formOrganizationNoticeOfViolation: require('./pdf-images/form-organization-notice-of-violation.png'),
	formOrganizationNoticeOfViolationHighlight: require('./pdf-images/form-organization-notice-of-violation-highlight.png'),
	formBusinessAgreementPage1: require('./pdf-images/PMF-02-01.png'),
	formBusinessAgreementPage1Highlight: require('./pdf-images/PMF-02-01-highlight.png'),
	formBusinessAgreementPage2: require('./pdf-images/PMF-02-02.png'),
	formBusinessAgreementPage2Highlight: require('./pdf-images/PMF-02-02-highlight.png'),
	formBusinessAgreementPage3: require('./pdf-images/PMF-02-03.png'),
	formBusinessAgreementPage3Highlight: require('./pdf-images/PMF-02-03-highlight.png'),
	formAssessmentCertificate: require('./pdf-images/FRF-04.png'),
	formAssessmentCertificateHighlight: require('./pdf-images/FRF-04-highlight.png'),
	formMinistryOfJustice: require('./pdf-images/ARF-04.png'),
	formMinistryOfJusticeHighlight: require('./pdf-images/ARF-04-highlight.png'),
	formPublicHealthCenters: require('./pdf-images/ARF-05.png'),
	formPublicHealthCentersHighlight: require('./pdf-images/ARF-05-highlight.png'),
	formLetterOfReasonForInvitingForeignLanguageAssistant: require('./pdf-images/ARF-07.png'),
	formLetterOfReasonForInvitingForeignLanguageAssistantPage2: require('./pdf-images/ARF-07-02.png'),
	formLetterOfReasonForInvitingForeignLanguageAssistantPage3: require('./pdf-images/ARF-07-03.png'),
	formLetterOfReasonForInvitingForeignLanguageAssistantHighlight: require('./pdf-images/ARF-07-highlight.png'),
	formConsentToCollect: require('./pdf-images/ARF-08.jpeg'),
	formConsentToCollectHighlight: require('./pdf-images/ARF-08-highlight.jpg'),
	formMandatoryInsuranceConsent: require('./pdf-images/ARF-11.png'),
	formMandatoryInsuranceConsent1: require('./pdf-images/ARF-11-01.png'),
	formMandatoryInsuranceConsent2: require('./pdf-images/ARF-11-02.png'),
	formAccidentInsuranceDeductionAgreement: require('./pdf-images/ARF-12.png'),
	formWageGuaranteeCommitment: require('./pdf-images/FRF-13.png'),
	formAccidentInsuranceCommitment: require('./pdf-images/ARF-13.png'),
	formParentsOfInternationalStudents: require('./pdf-images/form-parents-of-international-students.png'),
	formParentsOfInternationalStudentsHighlight: require('./pdf-images/form-parents-of-international-students-highlight.png'),
	formHumanTraffickingPage1: require('./pdf-images/form-human-trafficking-1.png'),
	formHumanTraffickingPage1Highlight: require('./pdf-images/form-human-trafficking-1-highlight.png'),
	formHumanTraffickingPage2: require('./pdf-images/form-human-trafficking-2.png'),
	formHumanTraffickingPage2Highlight: require('./pdf-images/form-human-trafficking-2-highlight.png'),
	formHumanTraffickingPage3: require('./pdf-images/form-human-trafficking-3.png'),
	formHumanTraffickingPage3Highlight: require('./pdf-images/form-human-trafficking-3-highlight.png'),
	formAgriculturalWorkplaceSafetyChecklistForEmployers: require('./pdf-images/agricultural-workplace-safety-checklist-for-employers.png'),
	formAgriculturalWorkplaceSafetyChecklistForWorkers: require('./pdf-images/agricultural-workplace-safety-checklist-for-workers.png'),
	formARFApplicant: require('./pdf-images/ARF-11-applicant.png'),
	formARFApplicant2: require('./pdf-images/ARF-11-applicant-2.png'),
	formARFFranchise: require('./pdf-images/ARF-11-franchise.png'),
	formARFFranchise2: require('./pdf-images/ARF-11-franchise-2.png'),
	formForRecruitingForeignWorkers: require('./pdf-images/form-for-recruiting-foreign-workers.png'),
	formForRecruitingForeignWorkers2: require('./pdf-images/form-for-recruiting-foreign-workers-2.png'),
	formIntroductionForParticipationInLaborUnion: require('./pdf-images/form-introduction-for-participation-in-the-labor-union.png'),
	//#endregion

	//#foreign
	iconPasswordWarning: require('./icon_password_warning.svg').default,
	//#endForeign
	iconPrint: require('./icon_printer.svg').default,

	iconDetail: require('./icon_detail.svg').default,
	iconEdit: require('./icon_edit.svg').default,
	iconDelete: require('./icon_delete.svg').default,
};

export const ImagesMobile = {
	iconLogo: require('./mobile/logo.svg').default,
	iconEmail: require('./mobile/icon_email.svg').default,
	iconPassword: require('./mobile/icon_password.svg').default,
	iconHamburger: require('./mobile/icon_hamburger.svg').default,
	iconBack: require('./mobile/icon_back.svg').default,
	iconCloseMenu: require('./mobile/icon_close_menu.svg').default,
	iconWorker: require('./mobile/icon_worker.svg').default,
	iconBusinessSite: require('./mobile/icon_business_site.svg').default,
	iconReferrer: require('./mobile/icon_referrer.svg').default,
	iconDocument: require('./mobile/icon_document.svg').default,
	iconSetting: require('./mobile/icon_setting.svg').default,
	iconLogout: require('./mobile/icon_logout.svg').default,
	iconMoreMenu: require('./mobile/icon_more_menu.svg').default,
	iconSearch: require('./mobile/icon_search.svg').default,
	iconAccommodation: require('./mobile/icon_accommodation.svg').default,
	iconPeriod: require('./mobile/icon_period.svg').default,
	iconDocumentList: require('./mobile/icon_document_list.svg').default,
	iconMoreTable: require('./mobile/icon_more_table.svg').default,
	iconPaginationPrev: require('./mobile/icon_pagination_prev.svg').default,
	iconPaginationNext: require('./mobile/icon_pagination_next.svg').default,
	iconPaginationStart: require('./mobile/icon_pagination_start.svg').default,
	iconPaginationEnd: require('./mobile/icon_pagination_end.svg').default,
	iconLodging: require('./mobile/icon_lodging.svg').default,
	iconAccordion: require('./mobile/icon_accordion.svg').default,
	iconClear: require('./mobile/icon_clear.svg').default,
	iconCamera: require('./mobile/icon_camera.svg').default,
	iconPagePreview: require('./mobile/icon_page_preview.svg').default,
	iconCloseModal: require('./mobile/icon_close_modal.svg').default,
};
